/* フッターエリア */
import React from 'react';
import ReturnMenuButton from './ReturnMenuButton';

interface Props {
  is_staff: boolean;
  is_on_change: boolean;
}

const FooterButtonShelf: React.FC<Props> = ({ is_staff, is_on_change }) => {
  return (
    <div className="footer-button-group mx-auto px-0 col-11 col-xs-10 col-lg-9">
      <ReturnMenuButton is_on_change={is_on_change} is_staff={is_staff} />
    </div>
  );
};

export default FooterButtonShelf;
